<template>
    <el-container style="height: 85vh">
        <el-aside width="300px">
            <div class="add-question" style="margin-bottom: 10px;display: flex;justify-content: center;align-items: center" @mouseenter="inHover(true)" @mouseleave="inHover(false)">
<!--                <div style="height: 30px;" :style="{display: isIn ? 'none' : 'block'}">-->
<!--                    创建新的大题-->
<!--                </div>-->
<!--                <div style="height: 20px;" :style="{display: !isIn ? 'none' : 'block'}">-->
<!--                    <el-button type="primary" size="mini" plain v-for="item in videoLocationList" @click="insertBack(item.key)">{{item.value}}题</el-button>-->
<!--                </div>-->
<!--                <div style="font-size: 16px;text-align: left;margin-bottom: 8px">创建新的大题</div>-->
<!--                <el-button style="margin-bottom: 6px" type="primary" size="mini" plain v-for="item in videoLocationList" @click="insertBack(item.key)">{{item.value}}题</el-button>-->
                <el-button type="primary" size="small" @click="dialogAdd">创建题型</el-button>
<!--                <button type="button" @click="dialogAdd" style="margin-bottom: 6px" class="el-button btn el-button&#45;&#45;primary"><span>添加试题</span></button>-->
            </div>
            <EduCreateExampaperAside style="height: 89%;overflow-y: auto;" @editName="editName" @sublist="sublist" @updateRows="updateRows" @subScore="subScore" ref="aside"></EduCreateExampaperAside>
        </el-aside>
        <el-container>
            <div class="box" style="margin: 0px 10px;flex: 1;padding-top: 0">
                <h3 class="exam-title elsc" style="display: flex;justify-content: center;align-items: center">{{paperName}}</h3>
                <div class="el-divider el-divider--horizontal"></div>
                <EduCreateExampaperMain style="height: 90%;overflow-y: auto" @updateRowsIn="updateRows" @sublist="sublist" ref="main"></EduCreateExampaperMain>
            </div>
        </el-container>
        <!-- 新增/查看/修改信息 -->
        <el-dialog
            title="创建题型"
            :visible.sync="showDialog"
            width="400px"
            @close="closeDialog"
            :append-to-body="true"
        >
            <div>
                <el-form
                    :model="tempItem"
                    ref="eduDialogForm"
                    :rules="rules"
                    label-width="90px"
                    :inline="true"
                    size="small"
                >
                    <el-form-item
                        label="题型分类"
                        prop="exerciseType"
                    >
                        <!--            <el-input-->
                        <!--              size="small"-->
                        <!--              v-model="eduKnowledge.parentId"-->
                        <!--              :disabled="eduKnowledgeState == 'check'"-->
                        <!--            ></el-input>-->
                        <el-select
                            clearable
                            style="width: 177px"
                            v-model="tempItem.exerciseType"
                            placeholder="请选择"
                            size="small"
                        >
                            <el-option
                                v-for="item in videoLocationList"
                                :label="item.value"
                                :value="item.key"
                                :key="item.key"
                            > </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item
                        label="题型名称"
                        prop="itemName"
                    >
                        <el-input
                            size="small"
                            style="width: 177px"
                            v-model="tempItem.itemName"
                        ></el-input>
                    </el-form-item>
                </el-form>
            </div>

            <div
                slot="footer"
                class="flex justify-end"
            >
                <el-button @click="closeDialog">关闭</el-button>
                <el-button
                    type="primary"
                    @click="insertBack"
                >确定</el-button>
            </div>
        </el-dialog>
    </el-container>
</template>

<script>
import EduCreateExampaperAside from '@/components/edu/EduCreateExampaperAside.vue'
import EduCreateExampaperMain from '@/components/edu/EduCreateExampaperMain.vue'
import GridSelectU from '@/components/gridselect/index.vue';
import { get, postJson } from '@/utils/request';
export default {
    components: {
        GridSelectU,
        EduCreateExampaperAside,
        EduCreateExampaperMain
    },
    created() {
        this.getEnums();
    },
    watch:{
        'tempItem.exerciseType':{
            handler(val){
                console.log(val)
                for (let item of this.videoLocationList) {
                    if(item.key == val){
                        this.tempItem.itemName = item.value + '题';
                        return
                    }
                }
            },deep: true, immediate: true
        }
    },
    data() {
        return {
            isIn: false,
            dateList: [],
            videoLocationList: [],
            paperName: '',
            id: '',
            count: 0,
            showDialog: false,
            tempItem: {
                exerciseType: null,
                itemName: "",
            },
            rules:{
                exerciseType: [
                    { required: true, message: '请选择题目类型', trigger: 'blur' },
                ],
                itemName: [
                    { required: true, message: '请输入题目名称', trigger: 'blur' },
                ]
            }
        }
    },
    methods:{
        inHover(sign){
            this.isIn = sign;
        },
        dialogAdd(){
            this.showDialog = true;
        },
        closeDialog(){
            this.showDialog = false;
            this.tempItem = {
                exerciseType: null,
                itemName: "",
            }
        },
        insertBack(){
            this.$refs.eduDialogForm.validate((valid) => {
                if(valid){
                    let obj = {
                        exerciseType: this.tempItem.exerciseType, //题型
                        itemName: this.tempItem.itemName, //题型名称
                        sort: this.dateList.length + 1, //排序
                        everyScore: 1, //每题分数
                        totalSize: 0, //共计题数
                        totalScore: 0, //共计分数
                        list: [],
                        exampaperId: this.id
                    }
                    this.dateList.push(obj)
                    this.closeDialog();
                    this.saveAndGet();
                }
            })
        },
        init(id){
            this.id = id
            get(`/edu/exampaper/findItem?exampaperId=${id}`).then((res) => {
                if (res.success) {
                    for (let item of res.data) {
                        for (let items of item.list) {
                            items.isOpen = false
                        }
                    }
                    this.dateList = res.data;
                    this.$refs.aside.init(this.dateList);
                    this.$refs.main.init(this.dateList);
                }
            });
        },
        getEnums(){
            get(`/edu/utils/getEnum?enumType=exercise_type`).then((res) => {
                if (res.success) {
                    this.videoLocationList = res.enumList;
                }
            });
        },
        reset(){
            this.dateList = [];
            this.$refs.aside.init(this.dateList);
            this.$refs.main.init(this.dateList);
            this.paperName = '';
            console.log(this.dateList)
        },
        sublist(index,list){
            this.count = 0;
            if(index + 1 == this.dateList.length){
                this.dateList.forEach(item => {
                    this.count += item.totalSize;
                })
                for (let listElement of list) {
                    let obj = {
                        seq: ++this.count,
                        exercise: listElement,
                        exerciseId: listElement.id,
                        itemId: this.dateList[index].id,
                    }
                    this.dateList[index].list.push(obj);
                }
            }else{
                this.count = this.dateList[index].list.length;
                for (let listElement of list) {
                    let obj = {
                        seq: ++this.count,
                        exercise: listElement,
                        exerciseId: listElement.id,
                        itemId: this.dateList[index].id,
                    }
                    this.dateList[index].list.push(obj);
                }
                for (let i = index + 1; i < this.dateList.length; i++) {
                    for (let listElement of this.dateList[i].list) {
                        listElement.seq = ++this.count;
                    }
                }
            }
            this.dateList[index].totalSize = this.dateList[index].list.length;
            this.dateList[index].totalScore = this.dateList[index].totalSize * this.dateList[index].everyScore;
            this.saveAndGet();
        },
        subScore(index, score){
            this.dateList[index].everyScore = score;
            this.dateList[index].totalScore = this.dateList[index].totalSize * this.dateList[index].everyScore;
            console.log("bckjzbn", this.dateList)
            this.saveAndGet();
        },
        updateRows(list){
            this.dateList = list;
            this.saveAndGet();
        },
        updateRowsIn(list){
            console.log(list)
            this.dateList = list;
            this.saveAndGet();
        },
        editName(index, itemName){
            this.dateList[index].itemName = itemName;
            this.saveAndGet();
        },
        saveAndGet(){
            postJson(`/edu/exampaper/saveItem`, {exampaperId: this.id, eduExampaperItemList: this.dateList}).then(res=>{
                if (res.success) {
                    get(`/edu/exampaper/findItem?exampaperId=${this.id}`).then((res) => {
                        if (res.success) {
                            for (let item of res.data) {
                                for (let items of item.list) {
                                    items.isOpen = false
                                }
                            }
                            this.dateList = res.data;
                            this.$refs.aside.init(this.dateList);
                            this.$refs.main.init(this.dateList);
                            this.$forceUpdate();
                        }else{
                            this.$message.error(res.msg);
                        }
                    });
                }else{
                    this.$message.error(res.msg);
                }
            })
        }
    }
}
</script>


<style lang="scss">
.box {
    padding: 10px;
    border-radius: 4px;
    border: 1px solid #ebeef5;
}
.el-main {
    padding: 0 !important;
}
.elsc{
    height: calc(7% - 25px);
}
h3 {
    display: block;
    font-size: 1.17em;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: bold;
    unicode-bidi: isolate;
}
.el-divider--horizontal {
    margin: 12px 0 !important;
}
.box .box-question-group {
    border: 1px solid #ebeef5;
    margin-top: 10px;
}
.box .box-question-group h4 {
    margin: 0;
    background: #f5f7fa;
    padding: 10px;
}
.box .box-question-group .now_q_type {
    margin-left: 15px;
    font-size: 18px;
}
.box .btn {
    margin-left: 15px;
}
.box .box-question {
    padding: 10px 20px;
}
.el-row {
    margin-bottom: 20px;
}
.questionNo {
    display: inline;
}
.questionbody p {
    margin: 2px 0;
}
.questionNo+p {
    display: inline-block;
    width: calc(100% - 50px);
    margin: 0;
}
.box .box-question .edit-btn .edit-icon {
    margin-top: 15px;
}
.add-question {
    padding: 10px 10px;
    border-radius: 4px;
    height: calc(7% + 10px);
    border: 1px solid #ebeef5;
    text-align: center;
}
.no-question {
    padding: 40px;
    text-align: center;
}
.active {
    color: #409eff;
}
</style>